import { useItemStore } from "@/itemStore";
import type { Term, Settings, Option } from "@/itemStore";
import { fetchMonth } from "@/fetch";

export const processSettings = (settings: Settings): void => {
  if (settings.showMonth) {
    fetchMonth().then(() => {
      console.debug("Fetched Months");
    });
  }
  if (window.location.hash) {
    setFilterFromHash(window.location.hash.substring(1));
  }
  window.addEventListener("popstate", () => {
    setFilterFromHash(window.location.hash.substring(1));
  });
};

export const setFilterFromHash = (hash: string): void => {
  const itemStore = useItemStore();
  if (itemStore.historyInhibit) {
    // This history event is caused by the mutation, and should be ignored.
    itemStore.historyInhibit = false;
  } else {
    for (const part of hash.split("/")) {
      const match = part.match(/^([^:]+):(.+)$/);
      if (match && itemStore.terms[match[1]]) {
        itemStore.filter[match[1]] = match[2].split(",");
      }
    }
  }
};
export function sortTerms (terms: Array<Term>): Array<Term> {
  return terms
    .filter((term: Term) => {
      return term.order > -1;
    })
    .sort((a: Term, b: Term) => {
      return a.order - b.order;
    });
}

/**
 * Creates an array of Options from a list of terms.
 */
export function makeOption(
  terms: Array<Term>,
  children = false,
  root = "",
  level = 0
): Array<Option> {
  const options: Array<Option> = [];
  for (const term of sortTerms(terms)) {
    const option: Option = {
      value: term.slug,
      text: term.name,
      level: level
    };
    options.push(option);
    if (children && term.children) {
      options.push(...makeOption(term.children, children, root, level + 1));
    }
  }
  return options;
}